export const PASSWORD_SYNC_COPY = {
  announcement: {
    title: 'One Password, Everywhere',
    body: 'Set up a single password for use across all Lumena platforms.',
    ctaButton: 'Set It Up',
    dismissButton: 'Not Now',
  },

  modal: {
    title: 'Set Up Password Sync',
    infoBanner:
      'This will be your password across all Lumena platforms. Reset anytime, using your mobile device.',
    passwordLabel: 'Password',
    passwordPlaceholder: 'Create a password',
    confirmLabel: 'Confirm Password',
    confirmPlaceholder: 'Re-enter your password',
    cancelButton: 'Cancel',
    submitButton: 'Enable Password Sync',
    submittingButton: 'Saving…',
    errorFallback: 'Could not save your password. Please try again.',
  },

  success: {
    title: 'Password Sync Enabled',
    heading: 'Password sync is active',
    body: 'You can now use this password to log in to any MindGym unit and Stellar.',
    doneButton: 'Done',
  },

  profileSection: {
    linkedHeading: 'Password Sync',
    linkedSubtitle: 'Your password works across all MindGym units and Stellar.',
    activeBadge: 'Active',
    unlinkedHeading: 'Password Sync',
    unlinkedSubtitle:
      'This will be your password across all Lumena platforms. Reset anytime, using your mobile device.',
    activateButton: 'Enable Password Sync',
  },
} as const;
